export enum AirPriceWatchCommonTrackingEventsName {
  watch_entry = "watch_entry",
  removed_watch = "removed_watch",
  added_watch = "added_watch",
  expired_watch = "expired_watch",
  tapped_watch = "tapped_watch",
  view_watches = "view_watches",
}
export type AirPriceWatchHTSEventProperties<Properties> = Properties;

export const AirPriceWatchEventName = {
  ...AirPriceWatchCommonTrackingEventsName,
};

export type AirPriceWatchEventName = typeof AirPriceWatchEventName;

export type AirPriceWatchProperties = {
  departure_date: string;
  destination?: string;
  destination_code?: string;
  destination_country_code?: string;
  destination_country_grouping?: string;
  destination_label?: string;
  destination_region_code?: string;
  origin?: string;
  origin_country_code?: string;
  origin_country_grouping?: string;
  origin_label?: string;
  origin_region_code?: string;
  return_date?: string;
};

export type TappedWatch = {
  name: AirPriceWatchCommonTrackingEventsName.tapped_watch;
  properties: AirPriceWatchHTSEventProperties<AirPriceWatchProperties>;
};

export type AddedWatch = {
  name: AirPriceWatchCommonTrackingEventsName.added_watch;
  properties: Record<string, unknown>;
};

export type RemovedWatch = {
  name: AirPriceWatchCommonTrackingEventsName.removed_watch;
  properties: Record<string, unknown>;
};

export type ExpiredWatch = {
  name: AirPriceWatchCommonTrackingEventsName.expired_watch;
  properties: Record<string, unknown>;
};

export type ViewWatches = {
  name: AirPriceWatchCommonTrackingEventsName.view_watches;
  properties: AirPriceWatchHTSEventProperties<{
    watches_active: number;
  }>;
};

export type WatchEntry = {
  name: AirPriceWatchCommonTrackingEventsName.watch_entry;
  properties: AirPriceWatchHTSEventProperties<{
    watches_active: number;
  }>;
};

export type AirPriceWatchHTSEvent =
  | TappedWatch
  | AddedWatch
  | RemovedWatch
  | ExpiredWatch
  | ViewWatches
  | WatchEntry;
